import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/css/bootstrap.css";
import "assets/scss/paper-dashboard.scss?v=1.3.0";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./views/index.css";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import AppWrapper from "AppWrapper";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<AppWrapper />);
